import { put, select, call } from 'redux-saga/effects';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { fetchMessageSessionAction } from '../fetchMessageSession/action';
import { fetchMessageAction } from '../fetchMessage/action';
import { selectContact } from '../../../state/contact/contactSlice';
import { formatPhone } from '../../../utils/phoneUtils';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { selectMessageSessions, deleteMessageSession } from '../../../state/message/messageSessionSlice';
import { showMessageNotification } from '../../../browser/notifications';

export function* incomingMessageSaga(newMessage) {
    yield put(fetchMessageSessionAction());
    yield put(fetchMessageAction(newMessage.session_id));

    const { messageSession, selectedMessageSessionId } = yield select(selectMessageSessions);
    const { uid } = yield select(selectUserCredentials);

    if (newMessage.type === 'chat-participant-remove-notification' && newMessage.text === uid) {
        // Delete the message session if the current user was removed
        yield put(deleteMessageSession(newMessage.session_id));
        console.log('Deleting messageSession')
        return; 
    }

    // If this is the currently selected session, don't show notifications
    if (selectedMessageSessionId === newMessage.session_id) {
        return;
    }

    const currentSession = messageSession.find(
        session => session['messagesession-id'] === newMessage.session_id
    )

    // If the session is muted, don't show notifications
    if (currentSession && currentSession['messagesession-muted'] === 'yes') {
        return;
    }

    const sender = newMessage.from_num ? newMessage.from_num : newMessage.from_uid;
    const { contact } = yield select(selectContact);
    const number = sender.split('@')[0];
    const matchingContact = contact.find(c => c.defaultNumber === number);


    let snackbarMessage;
    let notificationTitle;
    let notificationBody;


    const displayName = matchingContact
        ? `${matchingContact.first_name} ${matchingContact.last_name}`
        : formatPhone(String(number));

    if (newMessage.type === 'chat-name-change') {
        snackbarMessage = `${displayName} changed conversation name to "${newMessage.text}"`;
        notificationTitle = `${newMessage['session_name'] || 'Group Message'} says:`;
        notificationBody = `${displayName} changed conversation name to "${newMessage.text}"`;
    }
    else if (['chat-participant-leave', 'chat-participant-remove', 'chat-participant-remove-notification', 'chat-participant-add'].includes(newMessage.type)) {
        const participantNumber = newMessage.text.split('@')[0];
        const participantContact = contact.find(c => c.defaultNumber === participantNumber);
        const participantName = participantContact
            ? `${participantContact.first_name} ${participantContact.last_name}`
            : formatPhone(String(participantNumber));

        if (newMessage.type === 'chat-participant-add') {
            snackbarMessage = `${participantName} added to the conversation`;
            notificationTitle = `${newMessage['session_name'] || 'Group Message'}`;
            notificationBody = `${participantName} was added to the conversation`;

        } else if (newMessage.type === 'chat-participant-leave') {
            snackbarMessage = `${participantName} left the conversation`;
            notificationTitle = `${newMessage['session_name'] || 'Group Message'}`;
            notificationBody = `${participantName} left the conversation`;
        } else {
            snackbarMessage = `${participantName} was removed from the conversation`;
            notificationTitle = `${newMessage['session_name'] || 'Group Message'}`;
            notificationBody = `${participantName} was removed from the conversation`;
        }
    }
    else {
        snackbarMessage = `New message from ${displayName}`;
        notificationTitle = `${displayName} says:`;
        notificationBody = newMessage.text;
    }

    // Trigger a snackbar notification 
    yield put(showSnackbar({
        message: snackbarMessage,
        severity: 'info'
    }));

    // Show an OS notification; clicks come back through the service worker
    // and are handled globally in Sidebar (onMessageNotificationClick).
    yield call(showMessageNotification, {
        title: notificationTitle,
        body: notificationBody,
        sessionId: newMessage.session_id,
    });
}